module.exports = "img/16.45fbf2.webp";